import { styled } from '@mui/material/styles';
import { Box, Button, Grid } from '@mui/material';

export const StyledContainer = styled(Grid)(({ theme }) => ({
  height: '87vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  position: 'relative',
  padding: theme.spacing(2),
}));

export const StyledItem = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1, 0),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontSize: '18px',
}));

export const MoveAreaBox = styled(Box)(() => ({
  width: 250,
  height: 100,
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const EyeContainer = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
}));

export const EyeBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  borderRadius: '50%',
  height: '36px',
  width: '36px',
  background: theme.palette.common.white,
  border: `2px solid ${theme.palette.common.black}`,
  boxShadow: 'inset 0px 0px 5px rgba(0,0,0,0.5)',
}));

export const Pupil = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'x' && prop !== 'y',
})(({ x, y, theme }) => ({
  position: 'absolute',
  bottom: `calc(50% - 8px + ${y}px)`,
  right: `calc(50% - 8px + ${x}px)`,
  width: 13,
  height: 13,
  backgroundColor: theme.palette.common.black,
  borderRadius: '50%',
  boxShadow: '0px 0px 4px rgba(0,0,0,0.5)',
}));
